export class AuthenticateUserRequestModel {
  accessCode: string;
}
export class ValidUserModel {
  userAccessCode: string;
  userId: string;
  userAccessCodeId: number;
}
export class AuthenticatedUserModel {
  userGuid: string;
  loggedInName: string;
  iManageUserId: string;
  expiration: string;
  expirationInMinutes: number;
  isDownloadEmailEnabled: boolean;
  isDownloadDirectEnabled: boolean;
  maxMbFileDownload: number;
}
